import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const focus = (theme: Theme) => css`
  position: relative;
  max-width: ${width.container.large};
  margin: ${size[80]} auto;

  padding: ${size[24]};
  ${breakpoint.up('smMd')} {
    padding: ${size[128]} ${size[96]};
  }

  ${breakpoint.up('smMd')} {
    border-radius: 0 ${theme.borderRadius.xxl} 0 ${theme.borderRadius.xxl};
  }

  overflow: hidden;
`

export const title = (theme: Theme) => css`
  margin-top: 0;
  max-width: ${pxToRem(720)};
  color: ${theme.palette.text.title};
  font-weight: 700;

  margin-bottom: ${size[40]};
  ${breakpoint.up('smMd')} {
    margin-bottom: ${size[48]};
  }

  font-size: ${pxToRem(28)};
  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }

  span {
    color: #3bbab2;
  }
`

export const description = (theme: Theme) => css`
  color: ${theme.palette.text.body};
  max-width: ${pxToRem(960)};

  margin-bottom: ${size[40]};
  ${breakpoint.up('smMd')} {
    margin-bottom: ${size[48]};
  }

  font-size: ${pxToRem(18)};
  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(24)};
  }
`

export const background = css`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  right: 0;
  max-width: unset;
  z-index: -1;

  img {
    width: 100%;
    object-fit: cover;

    height: 100%;
    ${breakpoint.up('md')} {
      height: unset;
    }
  }

  &::after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(
      90.03deg,
      rgba(69, 13, 135, 0.9) 38.04%,
      rgba(69, 13, 135, 0.36) 71.68%,
      rgba(69, 13, 135, 0.36) 94.93%
    );
  }
`
